import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const TabGroupStyled = styled(Box, {
  borderBottom: '$borderWidths$1 solid $colors$coolGray200',
  display: 'flex',
  textAlign: 'left',
});
